import { call, put } from "redux-saga/effects"
import { push } from 'connected-react-router'
import { setAuth, loginFailed, resetAuth } from "../actions/auth"
import axios from 'axios'

import { Modal } from 'antd'
import config from '../config'

export function* login(action) {
    try {
        const user = action.payload
        const url = config.API_URL+"/login"

        const { 
            email, 
            password 
        } = user

        const formData = new FormData()
        formData.append("username",email)
        formData.append("password",password)

        const response = yield axios({
            method: 'post',
            url: url,
            data: formData,
        })
        localStorage.setItem(config.access_key, response.data.access_token)
        localStorage.setItem(config.refresh_key, response.data.refresh_token);
        yield put(setAuth(response.data));
        yield put(push("/"))

    } catch (error) {
        localStorage.removeItem(config.access_key);
        localStorage.removeItem(config.refresh_key);
        if(error.response){
            const message = error.response.data.message
            Modal.error({
                title: 'Login Failed',
                content: message,
            });
            yield put(loginFailed(message))
        }else{
            Modal.error({
                title: 'Login Failed',
                content: error.message,
            });
            yield put(loginFailed(error.message))
        }
    }
}

export function* logout(action){
    const url = config.API_URL+"/logout"
    try {
        const response = yield axios({
            method: 'post',
            url: url
        })
        yield put(resetAuth())
    }catch(error){
        Modal.error({
            title: 'Logout Failed',
            content: error.message,
        });
    }

}


export function* resetLogin(){
    localStorage.removeItem(config.access_key);
    localStorage.removeItem(config.refresh_key);
    delete axios.defaults.headers.common.authorization
    yield put(push("/login"))
}

export function* setLogin(action){
    axios.defaults.headers.common.authorization = "Bearer "+ action.payload.access_token
    localStorage.setItem(config.access_key, action.payload.access_token)
    localStorage.setItem(config.refresh_key, action.payload.refresh_token);
}